import { useCallback } from 'react';

import { DeleteConfirmation } from 'components/DeleteConfirmation';

import { useCommentMutation } from '.';
import DeleteCommentMutation from './mutations/deleteComment.papi.gql';

export const DeleteComment = ({ id, ...props }) => {
  const [deleteComment] = useCommentMutation(DeleteCommentMutation);

  const handleDelete = useCallback(async () => {
    await deleteComment({
      variables: {
        id,
      },
    });
  }, [id, deleteComment]);

  return (
    <DeleteConfirmation
      type="button"
      title="Delete Comment?"
      id="delete-comment-button"
      onDelete={handleDelete}
      warningContent={<span>Delete this comment?</span>}
      {...props}
    />
  );
};
